import { useQuery } from "@tanstack/react-query";
import { useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import api from "@/lib/api";
import VideoCard from "@/components/VideoCard";
import Seo from "@/components/Seo";
import { Loader2, SearchX } from "lucide-react";

export default function SearchPage() {
  const { t } = useTranslation();
  const [params] = useSearchParams();
  const q = params.get("q") || "";

  const { data, isLoading } = useQuery({
    queryKey: ["search", q],
    queryFn: async () => (await api.get("/search", { params: { q } })).data,
    enabled: !!q,
  });

  return (
    <div className="min-h-screen px-6 pt-24 md:px-12">
      <Seo title={`${t("common.search")}: ${q}`} description={t("brand.tagline")} />
      <h1 className="font-heading text-2xl font-bold tracking-tight md:text-3xl">
        {t("common.search")} · <span className="text-primary">{q}</span>
      </h1>

      {isLoading ? (
        <div className="flex h-64 items-center justify-center">
          <Loader2 className="h-7 w-7 animate-spin text-primary" />
        </div>
      ) : data?.length ? (
        <div className="mt-8 grid grid-cols-2 gap-4 pb-16 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5" data-testid="search-results">
          {data.map((v) => (
            <VideoCard key={v.id} video={v} className="w-full" />
          ))}
        </div>
      ) : (
        <div className="mt-16 flex flex-col items-center gap-3 text-muted-foreground">
          <SearchX className="h-10 w-10" />
          <p>{t("common.noResults")}</p>
        </div>
      )}
    </div>
  );
}
